<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center justify-content-between">
              <h6 class="mb-0 section-title">Configuración general</h6>
            </div>
          </div>
          <div class="card-body">
            <form @submit.prevent="save" v-if="loaded">
              <div class="row">
                <div class="col-md-6">
                  <label class="form-label">Nombre de la empresa</label>
                  <input v-model="form.company_name" type="text" class="form-control" placeholder="Nombre de la empresa" />
                </div>
                <div class="col-md-6">
                  <label class="form-label">Email</label>
                  <input v-model="form.email" type="email" class="form-control" placeholder="correo@ejemplo.com" />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6">
                  <label class="form-label">Teléfono</label>
                  <input v-model="form.phone" type="text" class="form-control" placeholder="Teléfono" />
                </div>
                <div class="col-md-6">
                  <label class="form-label">Dirección</label>
                  <input v-model="form.address" type="text" class="form-control" placeholder="Dirección" />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <label class="form-label">Descripción</label>
                  <textarea v-model="form.description" class="form-control" rows="3" placeholder="Descripción de la empresa"></textarea>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6">
                  <label class="form-label">Logo (tema claro)</label>
                  <input type="file" ref="logoPath" class="form-control" accept="image/jpeg,image/png,image/jpg" />
                  <p class="text-xs text-secondary mt-1">Opcional. JPEG, PNG. Máx. 2MB.</p>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Logo (tema oscuro)</label>
                  <input type="file" ref="logoPathDark" class="form-control" accept="image/jpeg,image/png,image/jpg" />
                  <p class="text-xs text-secondary mt-1">Opcional. JPEG, PNG. Máx. 2MB.</p>
                </div>
              </div>
              <div class="mt-4">
                <button type="submit" class="btn bg-gradient-warning" :disabled="saving">
                  <span v-if="saving">Guardando...</span>
                  <span v-else>Guardar cambios</span>
                </button>
              </div>
            </form>
            <div v-else class="text-center py-5">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2 text-sm">Cargando configuración...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "SettingsIndex",
  data() {
    return {
      loaded: false,
      saving: false,
      form: {
        company_name: "",
        description: "",
        email: "",
        phone: "",
        address: "",
      },
    };
  },
  mounted() {
    this.fetchSettings();
  },
  methods: {
    async fetchSettings() {
      try {
        const response = await this.$store.dispatch("settings/get");
        if (response && response.data) {
          const d = response.data;
          this.form = {
            company_name: d.company_name || "",
            description: d.description || "",
            email: d.email || "",
            phone: d.phone || "",
            address: d.address || "",
          };
        }
      } catch (error) {
        console.error("Error al cargar configuración:", error);
        this.$toast?.error?.("Error al cargar la configuración") || alert("Error al cargar la configuración.");
      } finally {
        this.loaded = true;
      }
    },
    async save() {
      this.saving = true;
      const formData = new FormData();
      formData.append("company_name", this.form.company_name);
      formData.append("description", this.form.description);
      formData.append("email", this.form.email);
      formData.append("phone", this.form.phone);
      formData.append("address", this.form.address);

      const logoFile = this.$refs.logoPath?.files?.[0];
      const logoDarkFile = this.$refs.logoPathDark?.files?.[0];
      if (logoFile) formData.append("logo_path", logoFile);
      if (logoDarkFile) formData.append("logo_path_dark", logoDarkFile);

      try {
        const response = await this.$store.dispatch("settings/save", formData);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire("Éxito", "Configuración guardada correctamente.", "success");
          await this.fetchSettings();
          if (logoFile || logoDarkFile) {
            window.location.reload();
          }
        } else {
          throw new Error(response?.data?.message || "Error al guardar");
        }
      } catch (error) {
        console.error("Error al guardar:", error);
        this.$toast?.error?.(error?.response?.data?.message || "Error al guardar la configuración") ||
          alert(error?.response?.data?.message || "Error al guardar la configuración.");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
